/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Rail_Scan_BodyInputs */

const en_portal_rail_scan_body = /** @type {(inputs: Portal_Rail_Scan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Snap your plate and the app counts calories and macros.`)
};

const pl_portal_rail_scan_body = /** @type {(inputs: Portal_Rail_Scan_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotografujesz talerz, a aplikacja liczy kalorie i makro.`)
};

/**
* | output |
* | --- |
* | "Snap your plate and the app counts calories and macros." |
*
* @param {Portal_Rail_Scan_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_rail_scan_body = /** @type {((inputs?: Portal_Rail_Scan_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Rail_Scan_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_rail_scan_body(inputs)
	return en_portal_rail_scan_body(inputs)
});